import {HttpErrorResponse,HttpHeaders,HttpResponse} from '@angular/common/http';
import {Component,Input,OnChanges,OnDestroy,OnInit,SimpleChanges} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService,JhiEventManager,JhiParseLinks} from 'ng-jhipster';
import {Subscription,of} from 'rxjs';

import {Principal} from 'src/app/core';
import {ICargoGroupMySuffix} from 'src/app/shared/model/cargo-group-my-suffix.model';

import {ITEMS_PER_PAGE} from 'src/app/shared/constants/pagination.constants';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {CargoGroupMySuffixService} from './cargo-group-my-suffix.service';
declare let $:any;
import { debounce } from "lodash";
import { CommonUtils } from 'src/app/shared/util/common-utils';

@Component({
    selector: 'jhi-cargo-group-my-suffix',
    templateUrl: './cargo-group-my-suffix.component.html'
})
export class CargoGroupMySuffixComponent implements OnChanges, OnInit, OnDestroy {

    @Input() masterIdList: any[]=[];
    
    public readonly RoleUtil = RoleUtil;

    currentAccount: any;
    cargoGroups: ICargoGroupMySuffix[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    searchText: string;
    flag: boolean;
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;
    cargoId: number;
    modalTitle: string = 'Confirm operation';
    modalContent: string;
    status: string = '';
    showActiveModel: boolean = false;

    constructor(
        private cargoGroupService: CargoGroupMySuffixService,
        private parseLinks: JhiParseLinks,
        private jhiAlertService: JhiAlertService,
        public principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private eventManager: JhiEventManager,
        private languageChangeService:LanguageChangeService,
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data.pagingParams.page;
            this.previousPage = data.pagingParams.page;
            this.reverse = data.pagingParams.ascending;
            this.predicate = data.pagingParams.predicate;
            // if (this.itemsPerPage == 25 && this.page > 1) {
            //     this.page = 1;
            //     this.previousPage = 1;
            // }
        });
        this.languageChangeService.refreshLanguage();
        this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            if (paramMap.get('size')) {
                this.itemsPerPage = paramMap.get('size')
            }
            const refresh = paramMap.get('refresh');
            if (refresh) {
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    loadAll() {
        this.searchText = '';
        this.cargoGroupService
            .query({
                page: this.page - 1,
                size: this.itemsPerPage,
                sort: this.sort()
            })
            .subscribe(
                (res: HttpResponse<ICargoGroupMySuffix[]>) => this.paginateCargoGroups(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        if (this.searchText) {
            this.searchItems();
            this.flag = true;
        } else {
            this.router.navigate(['/data-management/cargo-group'], {
                queryParams: {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                }
            });
            this.loadAll();
        }
    }

    clear() {
        this.page = 0;
        this.router.navigate([
            '/data-management/cargo-group',
            {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        ]);
        this.loadAll();
    }
    addZeroPadding: boolean;
    ngOnInit() {
        this.principal.setTitle("Cargo Groups");
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        const myObservable = of(1, 2, 3);
        const myObserver = {
            next: x => console.log('Observer got a next value: ' + x),
            error: err => console.error('Observer got an error: ' + err),
            complete: () => console.log('Observer got a complete notification'),
        };


        // Execute with the observer object
        myObservable.subscribe(myObserver);




        this.loadAll();
        this.principal.identity().then(account => {
            this.currentAccount = account;
            if (this.currentAccount.userRole != "BROKER" && this.currentAccount.userRole != "BROKER_STAFF") {
                this.addZeroPadding = true;
            } else {
                this.addZeroPadding = false;
            }
        });
        
        this.registerChangeInCargoGroups();
        console.log(this.masterIdList)
    }

    ngOnDestroy() {
        console.log(this.masterIdList)
        if (this.eventSubscriber) 
        this.eventManager.destroy(this.eventSubscriber);
    }

    ngOnChanges(changes: SimpleChanges) {
        console.log(this.masterIdList)
    }

    trackId(index: number, item: ICargoGroupMySuffix) {
        return item.id;
    }

    registerChangeInCargoGroups() {
        this.eventSubscriber = this.eventManager.subscribe('cargoGroupListModification', response => this.loadAll());
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    private paginateCargoGroups(data: ICargoGroupMySuffix[], headers: HttpHeaders) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
        this.queryCount = this.totalItems;
        this.cargoGroups = data;
        this.cargoGroups.forEach(res => {
            res.hsCode = Number(res.taricCode)
        })
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }
    searchItems() {
        // if (this.searchText) {
        //     let pNo = 0;
        //     let size = this.itemsPerPage;
        //     if (this.flag == true) {
        //         pNo = this.page - 1;
        //         size = this.itemsPerPage;
        //         this.flag = false;
        //     }
        //     this.principal
        //         .searchQuery(this.searchText, 'cargo-groups/search', {
        //             page: pNo,
        //             size: size,
        //             sort: this.sort()
        //         })
        //         .subscribe(
        //             (res: HttpResponse<ICargoGroupMySuffix[]>) => this.paginateCargoGroups(res.body, res.headers),
        //             (res: HttpErrorResponse) => this.onError(res.message)
        //         );
        // } else {
        //     this.loadAll();
        // }

        this.searchUsingDebounce();
    }

    // history
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;

    parentHistoryToggle = false;
    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Cargo (' + Obj.name + ') History';
        this.historyType = "CARGO_GROUP_AUDIT";
        this.historyId = Obj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    }

    viewFutureHistory(Obj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Cargo (' + Obj.name + ') Future Records';
        this.historyType = "CARGO_GROUP_AUDIT";
        this.historyId = Obj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    }
    onChange(value) {
        this.page = 0;
        this.itemsPerPage = value
        this.loadAll();
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }

    openActivateModal(status, cargoId) {
        this.showActiveModel = true;
        this.cargoId = cargoId;
        if (status == 'ACTIVATE') {
            this.modalContent = 'Are you sure you want to activate this  Cargo Group?'
            this.status = 'ACTIVE';
        } else {
            this.modalContent = 'Are you sure you want to In-activate this Cargo Group?'
            this.status = 'IN_ACTIVE'
        }
    }

    changeCargoStatus() {
        if (this.cargoId) {
            this.cargoGroupService.delete(this.cargoId).subscribe(response => {
                if (this.status == 'ACTIVE') {
                    this.jhiAlertService.success('The cargo group has been activated successfully')
                } else {
                    this.jhiAlertService.success('The cargo group has been de-activated successfully')
                }
                this.loadAll();
            });
        }
    }

    closeActiveModels(e: boolean) {
        this.showActiveModel = e;
    }

    searchUsingDebounce = debounce(params => {
        if (this.searchText) {
            let pNo = 0;
            let size = this.itemsPerPage;
            if (CommonUtils.isNotNil(this.flag) && CommonUtils.isTrue(this.flag)) {
                pNo = this.page - 1;
                size = this.itemsPerPage;
                this.flag = false;
            } else {
                this.previousPage = this.page = 1;
            }
            this.principal
                .searchQuery(this.searchText, 'cargo-groups/search', {
                    page: pNo,
                    size: size,
                    sort: this.sort()
                })
                .subscribe(
                    (res: HttpResponse<ICargoGroupMySuffix[]>) => this.paginateCargoGroups(res.body, res.headers),
                    (res: HttpErrorResponse) => this.onError(res.message)
                );
        } else {
            this.loadAll();
        }
    }, 700);
}
